import { GetReportCategory } from '@/api/store'
import { Config } from '@/config'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, Box, DialogTitle, IconButton, DialogContent, DialogContentText, DialogActions, Button, Typography, Divider, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Cookies from 'universal-cookie'
import Image from "next/image";
import { useRouter } from 'next/router'

type Props = {}

export default function CommentReport({ setopen, open, store_id, reviewId, productId }: any) {

  const cookie = new Cookies();
  const authToken = cookie.get("token");
  const token = authToken !== "" ? authToken : null as any;
  const productType = "review" as string
  const [dataReportReview, setReportReview] = useState<any>([]) //data
  const router = useRouter();
  const [selectedValue, setSelectedValue] = useState<string | any>(null); //radio
  const [reason, setReason] = useState(""); //detail
  const [openSuccess,setOpenSuccess] = useState(false)


  const GetReportTypeReview = async () => {
    const res = await GetReportCategory(token, productType)
    setReportReview(res?.data)

  }
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
   
    setSelectedValue(event.target.value); 
    if (event.target.value !== "อื่นๆ") {
      setReason("");
    }
  };


 
  const handleReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setReason(event.target.value);
  };

  const handleToReportReview = async () => {
    const reportData = {
      category_id: selectedValue,
      report_detail: reason,
      product_id:productId,
      store_id:store_id,
      review_id: reviewId,
      report_owner:1

    };
    
    
    await axios({
      method: "post",
      url: `${Config.apiEndpoint}report/post-report-request`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },

      data: reportData,
    })
      .then((res) => {
        if(res.data.success === true){
          setopen(false)
          setOpenSuccess(true)
        }
       

      })
      .catch((error) => {
       
      });
   
  };


  const handleClose = () => {
    setOpenSuccess(false)
    router.reload();
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        await GetReportTypeReview();
      } catch (error) {
        console.error("Error fetching report type review:", error);
      }
    };

    fetchData();
  }, [token, productType]);

  
  
  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          setopen(false);
          setSelectedValue("");
          setReason("")
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth={"sm"}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            m: {
              xs: "20px 50px 0px 0px",
              md: "50px 50px 0px 50px",
              sm: "50px 50px 0px 50px",
              xl: "50px 50px 0px 50px",
              lg: "50px 50px 0px 50px"
            }
          }}
        >
          <DialogTitle id="alert-dialog-title" className="fontBold" sx={{ m: 0 }}>
            {"รายงานความคิดเห็น"}
          </DialogTitle>
          <IconButton onClick={() => {
            setopen(false); 
            setSelectedValue(""); 
            setReason("")
          }}>
            <FontAwesomeIcon icon={faClose} fontSize={16} />
          </IconButton>
        </Box>
        <DialogContent sx={{
          m: {
            xs: "none",
            md: "0px 50px 0px 50px",
            sm: "0px 50px 0px 50px",
            xl: "0px 50px 0px 50px",
            lg: "0px 50px 0px 50px"
          }
        }}>
          <DialogContentText id="alert-dialog-description">
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <Typography className="fontBold" sx={{ fontSize: "16px", color: "#292929" }}>โปรดเลือกปัญหา</Typography>
            </Box>
            <Divider sx={{ p: "5px" }}></Divider>
            {/* <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              value={selectedValue}
              name="radio-buttons-group"
              onChange={handleRadioChange} 
            >
              {dataReportReview.map((data: any, index: number) => (
                <FormControlLabel
                  key={index}
                  value={data?.id} 
                  control={<Radio />}
                  label={data?.category_title || "ไม่ระบุชื่อ"} 
                />
              ))}
            </RadioGroup> */}
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              value={selectedValue}
              name="radio-buttons-group"
              onChange={handleRadioChange}
            >
              {dataReportReview.map((data: any, index: number) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginBottom: "8px" 
                  }}
                >
                  <Radio
                    value={data?.id}
                    sx={{
                      padding: "0 18px 0 0", 
                      marginTop: "5px", 
                    }}
                  />
                  <Typography
                    sx={{
                      whiteSpace: "pre-wrap", 
                      lineHeight: 1.2,
                      color: "#000",
                      mt:"7px"
                    }}
                  >
                    {data?.category_title || "ไม่ระบุชื่อ"}
                  </Typography>
                </Box>
              ))}
            </RadioGroup>



            {selectedValue == 12 && (
          <>
                <Typography className="fontBold" sx={{ fontSize: "16px", color: "#292929" }}>รายละเอียด</Typography>
                <Box
                  component="form"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    "& .MuiTextField-root": { mt: 2, width: "100%" },
                  }}
                  noValidate
                  autoComplete="off"
                >


                  <TextField
                    className="borderTextField"
                    id="outlined-multiline-static"
                    label="โปรดระบุเหตุผล"
                    multiline
                    rows={4}
                    value={reason}
                    onChange={handleReasonChange}
                    fullWidth
                    margin="normal"
                  />

                </Box>
          </>
            )}
          </DialogContentText>


        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center", m: "0px 65px 50px 65px" }}>
          <Button variant="outlined" className="btn-success" fullWidth  onClick={handleToReportReview}>
            รายงาน
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSuccess}
        onClose={() => setOpenSuccess(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth={"sm"}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "30px 20px",
          }}
        >
        
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center", 
              width: "100%",
              marginBottom: "20px", 
            }}
          >
            <Image
              src="/assets/images/icon/ic_success.png"
              alt="success-icon"
              width={70}
              height={70}
            />
          </Box>

     
          <DialogContent
            sx={{
              width: "100%",
              textAlign: "center",
              margin: "10px 0",
            }}
          >
            <DialogContentText id="alert-dialog-description" className="fontBold" sx={{color:"#292929"}}>
              ขอบคุณสำหรับการรายงานความคิดเห็น
            </DialogContentText>
            <DialogContentText id="alert-dialog-description" sx={{ color: "#717275" ,mt:"10px"}}>
              ทางทีมงานจะตรวจสอบและดำเนินการให้เร็วที่สุด
            </DialogContentText>
          </DialogContent>

        
          <DialogActions
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              variant="outlined"
              className="btn-success"
              fullWidth
              onClick={handleClose}
            >
              ปิด
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

    </>
  )
}